import ChangedValueIndicator from './_changed-value-indicator.js'
import FlexPane from './_flex-pane.js'
import BetStatusIcon from './_bet-status-icon.js'
import Image from './_image.js'
import Text from './_text.js'
import DateTime from './_date-time.js'
import MatchAccaSelectionItem from './_match-acca-selection-item.js'
import OddsBoostNotification from './_odds-boost-notification.js'
import EarlyPayoutIndicator from './_early-payout-indicator.js'
import Hideable from './_hideable.js'

export default {
  name: 'BetLegsDetails',
  values: {
    showBetLegNotification: true,
    showLegDateTime: true,
    showEventStartDateTime: true,
    priceBoostIndicator: {
      configSet: ChangedValueIndicator,
      configValues: {
        container: {
          style: {
            alignItems: 'center',
          },
        },
        indicationIcon: {
          src: 'double-arrow-right',
          style: {
            minWidth: '12px',
            minHeight: '12px',
          },
        },
      },
    },
    legsItemInfo: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    infoContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    infoContainerMatchAcca: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    legStatusIconContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          alignItems: 'baseline',
          flexGrow: 0,
        },
      },
    },
    legStatusIcon: {
      configSet: BetStatusIcon,
      configValues: {
        open: {
          style: {
            width: '12px',
            height: '17px',
          },
        },
        lost: {
          style: {
            width: '12px',
            height: '17px',
          },
        },
        void: {
          style: {
            width: '12px',
            height: '17px',
          },
        },
        won: {
          style: {
            width: '12px',
            height: '17px',
          },
        },
        cashedOut: {
          style: {
            width: '12px',
            height: '17px',
          },
        },
      },
    },
    bestOddsIcon: {
      configSet: Image,
      configValues: {
        src: 'racing-bestodds',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    selectionContainer: {
      configSet: FlexPane,
      configValues: {},
    },
    selectionNameContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    selectionName: {
      configSet: Text,
      configValues: {},
    },
    marketName: {
      configSet: Text,
      configValues: {},
    },
    eventName: {
      configSet: Text,
      configValues: {},
    },
    eventNameDateTimeFormat: {
      configSet: DateTime,
      configValues: {},
    },
    matchAccaInfo: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
      },
    },
    matchAccaSelectionItem: {
      configSet: MatchAccaSelectionItem,
      configValues: {
        selectionContainer: undefined,
      },
    },
    matchAccaEventName: {
      configSet: Text,
      configValues: {
        container: {
          padding: '0 0 8px 0',
        },
      },
    },
    matchAccaOddsBoostNotification: {
      configSet: OddsBoostNotification,
      configValues: {
        container: {
          style: {
            padding: '8px 0 4px 0',
          },
        },
      },
    },
    notificationContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
      },
    },
    oddsBoostNotification: {
      configSet: OddsBoostNotification,
      configValues: {},
    },
    earlyPayoutIndicator: {
      configSet: EarlyPayoutIndicator,
      configValues: {
        popover: {
          popup: {
            container: {
              style: {
                top: '32px',
              },
            },
          },
        },
      },
    },
    oddsLabel: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    extraFields: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    legDateTimeContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
        },
      },
    },
    legDateInfoText: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    legDateTimeFormat: {
      configSet: DateTime,
      configValues: {},
    },
    eventStartDateTime: {
      configSet: Hideable,
      configValues: {
        hide: true,
      },
    },
    eventStartDateTimeText: {
      configSet: Text,
      configValues: {},
    },
    eventStartDateTimeFormat: {
      configSet: DateTime,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
